import api from 'shared/api';

export const updateLicenseProductFeature = (featureId, payload) => {
  const url = `/api/v1/license-product-features/${featureId}/`;
  return api.patch(url, payload);
};

export const deleteLicenseProductFeature = (featureId) => {
  const url = `/api/v1/license-product-features/${featureId}/`;
  return api.delete(url);
};

export const createLicenseFeature = (payload) => {
  const url = `/api/v1/license-product-features/`;
  return api.post(url, payload);
};

export const fetchLicenseProductFeatures = (licenseId, sortOptions = []) => {
  const sortQuery =
    sortOptions.length > 0
      ? `&order_by=${sortOptions
          .map((option) => `${option.desc ? '-' : ''}${option.id}`)
          .join(',')}`
      : '';
  const url = `/api/v1/license-product-features/?license=${licenseId}${sortQuery}`;
  return api.get(url);
};

export const patchLicense = (licenseId, payload) => {
  const url = `/api/v1/licenses/${licenseId}/`;
  return api.patch(url, payload);
};

export const fetchLicensesByLicenseUser = (licenseUserId) =>
  api.get(`/api/v1/licenses/?license_users__id=${licenseUserId}`);

export const fetchDevicesByLicenseUser = (licenseUserId) =>
  api.get(`/api/v1/devices/?license_users__id=${licenseUserId}`);

export const fetchLicenseUserGroups = (licenseUserId) =>
  api.get(`/api/v1/users/${licenseUserId}/groups/`);
